/** @format */

import React from "react";
import "../styles/Accordion.css";

const Accordion = () => {
  return (
    <div className='bg acontainer'>
      <h3>Frequently Asked Questions</h3>
      <div className='accordion' id='accordionExample'>
        <div className='accordion-item  '>
          <h2 className='accordion-header ' id='headingOne'>
            <button
              btn
              className='accordion-button accordion-style'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#collapseOne'
              aria-expanded='true'
              aria-controls='collapseOne'
            >
              What is Netflix?
            </button>
          </h2>
          <div
            id='collapseOne'
            className='accordion-collapse collapse show'
            aria-labelledby='headingOne'
            data-bs-parent='#accordionExample'
          >
            <div className='accordion-body aaccordion-style'>
              <strong></strong> Netflix is a streaming service that offers a
              wide variety of award-winning TV shows, movies, anime,
              documentaries, and more on thousands of internet-connected
              devices. You can watch as much as you want, whenever you want
              without a single commercial – all for one low monthly price.
              There's always something new to discover and new TV shows and
              movies are added every week!
            </div>
          </div>
        </div>
        <div className='accordion-item'>
          <h2 className='accordion-header' id='headingTwo'>
            <button
              className='accordion-button collapsed accordion-style'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#collapseTwo'
              aria-expanded='false'
              aria-controls='collapseTwo'
            >
              How much does Netflix cost?
            </button>
          </h2>
          <div
            id='collapseTwo'
            className='accordion-collapse collapse'
            aria-labelledby='headingTwo'
            data-bs-parent='#accordionExample'
          >
            <div className='accordion-body aaccordion-style'>
              Watch Netflix on your smartphone, tablet, Smart TV, laptop, or
              streaming device, all for one fixed monthly fee. Plans range from
              ₦1,200 to ₦4,400 a month. No extra costs, no contracts.
            </div>
          </div>
        </div>
        <div className='accordion-item'>
          <h2 className='accordion-header' id='headingThree'>
            <button
              className='accordion-button collapsed accordion-style'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#collapseThree'
              aria-expanded='false'
              aria-controls='collapseThree'
            >
              Where can I watch?
            </button>
          </h2>
          <div
            id='collapseThree'
            className='accordion-collapse collapse'
            aria-labelledby='headingThree'
            data-bs-parent='#accordionExample'
          >
            <div className='accordion-body aaccordion-style'>
              Watch anywhere, anytime. Sign in with your Netflix account to
              watch instantly on the web at netflix.com from your personal
              computer or on any internet-connected device that offers the
              Netflix app, including smart TVs, smartphones, tablets, streaming
              media players and game consoles. You can also download your
              favorite shows with the iOS, Android, or Windows 10 app. Use
              downloads to watch while you're on the go and without an internet
              connection. Take Netflix with you anywhere.
            </div>
          </div>
        </div>
        <div className='accordion-item'>
          <h2 className='accordion-header' id='headingFour'>
            <button
              className='accordion-button collapsed accordion-style'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#collapseFour'
              aria-expanded='false'
              aria-controls='collapseFour'
            >
              How do I cancel?
            </button>
          </h2>
          <div
            id='collapseFour'
            className='accordion-collapse collapse'
            aria-labelledby='headingFour'
            data-bs-parent='#accordionExample'
          >
            <div className='accordion-body aaccordion-style'>
              Netflix is flexible. There are no pesky contracts and no
              commitments. You can easily cancel your account online in two
              clicks. There are no cancellation fees – start or stop your
              account anytime.
            </div>
          </div>
        </div>
        <div className='accordion-item'>
          <h2 className='accordion-header' id='headingFive'>
            <button
              className='accordion-button collapsed accordion-style'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#collapseFive'
              aria-expanded='false'
              aria-controls='collapseFive'
            >
              What can I watch on Neflix?
            </button>
          </h2>
          <div
            id='collapseFive'
            className='accordion-collapse collapse'
            aria-labelledby='headingFive'
            data-bs-parent='#accordionExample'
          >
            <div className='accordion-body aaccordion-style'>
              Netflix has an extensive library of feature films, documentaries,
              TV shows, anime, award-winning Netflix originals, and more. Watch
              as much as you want, anytime you want.
            </div>
          </div>
        </div>
        <div className='accordion-item'>
          <h2 className='accordion-header' id='headingSix'>
            <button
              className='accordion-button collapsed accordion-style'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#collapseSix'
              aria-expanded='false'
              aria-controls='collapseSix'
            >
              is Netflix good for Kid?
            </button>
          </h2>
          <div
            id='collapseSix'
            className='accordion-collapse collapse'
            aria-labelledby='headingSix'
            data-bs-parent='#accordionExample'
          >
            <div className='accordion-body aaccordion-style'>
              The Netflix Kids experience is included in your membership to give
              parents control while kids enjoy family-friendly TV shows and
              movies in their own space. Kids profiles come with PIN-protected
              parental controls that let you restrict the maturity rating of
              content kids can watch and block specific titles you don't want
              kids to see.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
